<style>
	 @import '@/assets/css/custom.css';
</style>

<template>
    <div>
        <Breadcrumbs main="Work Management" title="Company Titles" />

		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					<div class="card">
						<div class="card-body">

							<div class="col-md-12 project-list page-subtitle">
								<div class="row">
									<div class="col-md-12">
										<button class="btn btn-primary float-end" @click="updateCompanyTitleModalShow">Add Company Title</button>
									</div>
								</div>
							</div>

							<div class="col-md-12 project-list filter-sort">
								<div class="row">
									<div class="col-md-10 d-flex mt-2">
										<label class="d-flex listing-length ms-1"><span>Show</span>
											<select class="form-select" v-model="listing_length" @change="fetchCompanyTitles()">
												<option value="5">5</option>
												<option value="10">10</option>
												<option value="20">20</option>
											</select>
											<span>entries</span>
										</label>
									</div>
									
									<div class="col-md-2 mt-2">
										<input type="text" class="form-control ms-1 float-end" placeholder="Search" v-model="keyword" @keyup="fetchCompanyTitles()"/>
									</div>
								</div>
							</div>

							<div class="table-responsive product-table">
								<table class="display" id="basic-1">
									<thead>
										<tr align="center">
                                            <th>Sl.No</th>  
                                            <th>Title</th>
											<th>Sub Title</th>
											<th>Image</th>
											<th>Action</th>
                                        </tr>
									</thead>
									<tbody v-if="Boolean(company_titles.length)">
										<tr align="center" v-for="(company_title, index) in company_titles" :key="index">
                                            <td>{{ (from - 1) + index + 1 }}</td>
											<td>
												{{ company_title.title }}
											</td>
											<td>
												{{ company_title.sub_title }}
											</td>
											<td>
												<img v-if="company_title.image" :src="imageUrl + company_title.image" class="avatar-sm" alt="Company Title Image" height="100" width="100"/>
											</td>
											<td>
												<button class="btn btn-primary btn-sm me-2 mb-2" @click="editCompanyTitle(company_title)">Edit</button>
											</td>
                                        </tr>
                                    </tbody>
									<tbody v-else>
										<tr>
											<td colspan="9" class="text-center">No company titles found</td>
										</tr>
									</tbody>
								</table>
							</div>

							<!----pagination starts --->
							<nav aria-label="Page navigation" class="mt-2">
								<ul class="pagination">
									<li class="page-item" v-for="(page, index) in pagination" :key="index" :class="[{ disabled: !page.url }, { active: page.active }]">
									<a class="page-link" href="#" @click.prevent="fetchCompanyTitles(page.url)" tabindex="-1">
										<span v-if="index === 0">Prev</span>
										<span v-else-if="index === pagination.length - 1">Next</span>
										<span v-else v-html="page.label"></span>
									</a>
									</li>
								</ul>
							</nav>
							<!----pagination ends --->
							
						</div>
					</div>
				</div>
			</div>
		</div>

		<DynamicModal :title=modal_title>
			<template #body>
				<form @submit.prevent="" enctype="multipart/form-data">
					<div class="row">
                        <div class="col-md-12 form-group mt-2">
                            <label class="control-label">Company Title<span class="text-danger">*</span></label>
                        	<input v-model="company_title" class="form-control" rows="3"/>
							<span class="validate-error" v-if="errors.company_title">
								{{ errors.company_title[0] }}
							</span>
                        </div>
						<div class="col-md-12 form-group mt-2">
							<label class="control-label">Sub Title<span class="text-danger">*</span></label>
							<input v-model="sub_title" class="form-control" rows="3"/>
							<span class="validate-error" v-if="errors.sub_title">
								{{ errors.sub_title[0] }}
							</span>
						</div>
						<div class="col-md-12 form-group mt-2">
							<label class="control-label">Image<span class="text-danger">*</span></label>
							<img v-if="company_title_data.image && !preview_image" :src="imageUrl + company_title_data.image" class="profile-image mb-2" alt="" height="100" width="100"/>
							<input ref="fileinput" type="file" @change="setFile($event)" accept="image/*" class="form-control image-class" v-bind:class="{ 'is-invalid': Boolean(errors.image) }"/>
							<img v-if="preview_image" class="profile-image mt-2" :src="preview_image" height="100" width="100"/>
							<span class="validate-error" v-if="errors.image">
								{{ errors.image[0] }}
							</span>
						</div>
                    </div>
					
					<div class="col-md-12 form-group mt-2">
						<button type="submit" class="btn btn-primary me-3" @click="addCompanyTitle()">{{ button_title }}</button>
						<button class="btn btn-light" type="button" @click="hideModal()">Close</button>
					</div>
				</form>
			</template>
		</DynamicModal>

	</div>
</template>

<script setup>
import { onMounted, ref, getCurrentInstance, reactive, inject } from 'vue';
import { useRouter } from 'vue-router';
import { routes } from '@/constants/routes';
import { get, post } from '@/utils/api';
import Swal from '@/utils/swal';
import { Modal } from 'bootstrap';
import DynamicModal from '@/components/dynamic_modal.vue';

const router = useRouter();
const { proxy } = getCurrentInstance();

const imageUrl = inject('imageUrl');
let modal = null;
const company_titles = ref([]);
const listing_length = ref(10);
const status = ref("");
const keyword = ref("");
const from = ref(null);
const to = ref(null);
const total = ref(null);
const pagination = ref({});

let modalInstance = null;
const modal_title = ref('Add Company Title');
const button_title = ref('Add');
const errors = ref({});
const company_title = ref('');
const sub_title = ref('');
const image = ref('');
const preview_image = ref('');
const edit_mode = ref(false);
const company_title_data = ref({
	id: '',
	title: '',
	sub_title: '',
	image: ''
});

const setFile = (e) => {
	if (e.target.files && e.target.files[0]) {
		image.value = e.target.files[0];
		preview_image.value = URL.createObjectURL(e.target.files[0]);
	}
};

const showModal = () => {
  	if (modalInstance) modalInstance.show();
};

const hideModal = () => {
  	if (modalInstance) modalInstance.hide();
};

const updateCompanyTitleModalShow = () => {
	clearForm();
	showModal();
};

const clearFileInput = () => {
	const fileInput = document.querySelector('input[type="file"]');
	if (fileInput) {
		fileInput.value = '';
	}
};

const clearForm = () => {
	edit_mode.value = false;
	company_title.value = '';
	sub_title.value = '';
	image.value = '';
	preview_image.value = '';
	modal_title.value = 'Add Company Title';
	button_title.value = 'Add';
	errors.value = {};
	company_title_data.value = {
		id: '',
		title: '',
		sub_title: '',
		image: ''
	};
	clearFileInput();
};

const fetchCompanyTitles = (url = null) => {

	const params = {
		limit: listing_length.value,
		keyword: keyword.value
	}

	const requestUrl = url ?? routes.CompanyTitles;

	get(requestUrl, { params }, false)
		.then((response) => {
			if(response.status === 200){
				console.log(response.data.data);
				company_titles.value = response.data.data.company_titles.data;
				pagination.value = response.data.data.company_titles.links;
				from.value = response.data.data.company_titles.from;
				to.value = response.data.data.company_titles.to;
				total.value = response.data.data.company_titles.total;
			} else {
				Swal.fire('', response.data.message || 'Failed to fetch company_titles', 'error');
			}
		})
		.catch((error)	=> {
			if (error.response?.status === 422) {
				Swal.fire('', error.response.data.message.limit?.[0] || error.response.data.message.status?.[0] || error.response.data.message.keyword?.[0] || 'Validation error', 'error');
			} else if (error.response?.status === 500) {
				Swal.fire('', error.response.statusText || 'Server error', 'error');
			} else if (error.response?.status === 401) {
				Swal.fire('', error.response.statusText || 'Unauthorized', 'error');
				router.push({ name: 'login' });
			} else {
				Swal.fire('', error.response.data?.message || 'Error occured', 'error');
			}
		});
};

const editCompanyTitle = (company_title_item) => {
	edit_mode.value = true;
	company_title_data.value.id = company_title_item.id;
	company_title_data.value.title = company_title_item.title;
	company_title_data.value.sub_title = company_title_item.sub_title;
	company_title_data.value.image = company_title_item.image;
	
	company_title.value = company_title_item.title;
	sub_title.value = company_title_item.sub_title;
	
	// Clear image and preview when editing to show existing image
	image.value = '';
	preview_image.value = '';
	clearFileInput();
	
	modal_title.value = 'Edit Company Title';
	button_title.value = 'Update';
	showModal();
};

const fetchCompanyTitleDetails = (id) => {
	get(`${routes.companyTitleDetails}?id=${id}`, {}, false)
		.then((response) => {
			if(response.status === 200){
				const data = response.data.data;
				company_title_data.value = data;
				company_title.value = data.title;
				sub_title.value = data.sub_title;
			} else {
				Swal.fire('', response.data.message || 'Failed to fetch company title details', 'error');
			}
		})
		.catch((error) => {
			if (error.response?.status === 500) {
				Swal.fire('', error.response.statusText || 'Server error', 'error');
			} else if (error.response?.status === 401) {
				Swal.fire('', error.response.statusText || 'Unauthorized', 'error');
				router.push({ name: 'login' });
			} else {
				Swal.fire('', error.response.data?.message || 'Error occurred', 'error');
			}
		});
};

const addCompanyTitle = () => {
	const formData = new FormData();
	formData.append('title', company_title.value);
	formData.append('sub_title', sub_title.value);
	
	let url = routes.addCompanyTitle;
	
	if (edit_mode.value) {
		url = routes.updateCompanyTitle;
		formData.append('id', company_title_data.value.id);
		// Only append image if a new image is uploaded
		if(image.value){
			formData.append('image', image.value);
		}
	} else {
		// For add mode, image is required
		if(image.value){
			formData.append('image', image.value);
		}
	}
	
	post(url, formData, false)
		.then((response) => {
			if(response.status === 200){
				const message = edit_mode.value ? 'Company title updated successfully' : 'Company title added successfully';
				Swal.fire('', response.data.message || message, 'success');
				hideModal();
				clearForm();
				fetchCompanyTitles();
			} else {
				const message = edit_mode.value ? 'Failed to update company title' : 'Failed to add company title';
				Swal.fire('', response.data.message || message, 'error');
			}
		})
		.catch((error) => {
			if(error.response.status == 422){
				errors.value = error.response.data.message;
			} else if (error.response?.status === 500) {
				Swal.fire('', error.response.statusText || 'Server error', 'error');
			} else if (error.response?.status === 401) {
				Swal.fire('', error.response.statusText || 'Unauthorized', 'error');
				router.push({ name: 'login' });
			} else {
				Swal.fire('', error.response.data?.message || 'Error occurred', 'error');
			}
		});
};


onMounted(() => {
	modalInstance = new Modal(document.getElementById('dynamicmodal'));
	fetchCompanyTitles();
})

</script>